// Comparison selection model: an ordered set of forecast-root ids overlaid on a
// shared timeline. rootIds[0] is the focused ("primary") lane. Pure — no React,
// no I/O. See design doc D1.

export const MAX_COMPARE_ROOTS = 2;

export function emptySelection() {
  return { rootIds: [] };
}

// Compare mode is "active" once at least two roots are selected.
export function isCompareActive(sel) {
  return (sel?.rootIds?.length || 0) >= 2;
}

// Plain log-row click: open one root as the single focused lane.
export function setFocused(_sel, rootId) {
  return { rootIds: [rootId] };
}

// Shift+click a log row: toggle it into/out of the comparison, capped.
// - already present -> remove it
// - room under the cap -> append (becomes the next lane)
// - at the cap with a new id -> no-op (returns the same set)
export function toggleCompare(sel, rootId, { max = MAX_COMPARE_ROOTS } = {}) {
  const ids = sel?.rootIds || [];
  if (ids.includes(rootId)) return { rootIds: ids.filter((id) => id !== rootId) };
  if (ids.length >= max) return sel;
  return { rootIds: [...ids, rootId] };
}

export function removeRoot(sel, rootId) {
  return { rootIds: (sel?.rootIds || []).filter((id) => id !== rootId) };
}
